import React, { CSSProperties } from 'react';
import { useAppSelector } from '../hook';
import { selectUserLogo } from '../theme-selectors';
import { ReactComponent as LogoFull } from 'assets/images/logo.svg';
import { ReactComponent as LogoNoText } from 'assets/images/logo-no-text.svg';

interface BrandLogoProps {
    // 'full' = logo có chữ, 'noText' = logo gọn (vd sidebar thu lại).
    variant?: 'full' | 'noText';
    width?: number | string;
    height?: number | string;
    onClick?: () => void;
    style?: CSSProperties;
    className?: string;
    alt?: string;
}

/**
 * Logo của hệ thống. Nếu user (từ API) có logo riêng -> hiện logo đó; ngược lại
 * fallback logo mặc định. Dùng chung cho header/sidebar/layout để logo đổi theo
 * từng user ở một chỗ duy nhất.
 */
// Kích thước gốc của logo (theo viewBox file svg). Dùng làm mặc định khi call
// site không truyền width/height, tránh inline SVG giãn full theo container.
const INTRINSIC = {
    full: { width: 138, height: 100 },
    noText: { width: 62, height: 62 },
};

const BrandLogo = ({
    variant = 'full',
    width,
    height,
    onClick,
    style,
    className,
    alt = 'logo',
}: BrandLogoProps) => {
    const userLogo = useAppSelector(selectUserLogo);
    const cursor = onClick ? 'pointer' : undefined;

    // Chỉ áp kích thước mặc định khi cả hai đều không truyền (giữ đúng tỉ lệ);
    // nếu chỉ truyền width thì để height tự co theo tỉ lệ.
    const sizeUnset = width === undefined && height === undefined;
    const finalWidth = sizeUnset ? INTRINSIC[variant].width : width;
    const finalHeight = sizeUnset ? INTRINSIC[variant].height : height;

    if (userLogo) {
        return (
            <img
                src={userLogo}
                alt={alt}
                width={finalWidth}
                height={finalHeight}
                onClick={onClick}
                className={className}
                style={{ cursor, objectFit: 'contain', ...style }}
            />
        );
    }

    const LogoComponent = variant === 'noText' ? LogoNoText : LogoFull;
    return (
        <LogoComponent
            width={finalWidth}
            height={finalHeight}
            onClick={onClick}
            className={className}
            style={{ cursor, ...style }}
        />
    );
};

export default BrandLogo;
